export default __webpack_public_path__ + "static/media/quick-share.2da7e80e.svg";